import { REGISTER_USER, REGISTER_USER_ERROR, TOGGLE_REGISTERING_USER, UserActionTypes } from './types';
import { AppState } from '../index';

export interface IUserReducerInitialState {
    isLogged: boolean;
    registeringUser: boolean;
    error: Error | null;
}
const INITIAL_STATE: IUserReducerInitialState = {
    isLogged: false,
    registeringUser: false,
    error: null,
};

export default function (state = INITIAL_STATE, action: UserActionTypes) {
    switch (action.type) {
        case REGISTER_USER:
            const { isLogged } = action;
            return { ...state, isLogged, registeringUser: false };
        case REGISTER_USER_ERROR:
            return {
                ...state,
                error: action.error,
                registeringUser: false,
            };
        case TOGGLE_REGISTERING_USER:
            const { registeringUser } = action;
            return {
                ...state,
                registeringUser: registeringUser,
            };
        default:
            return state;
    }
}
export const selectRegisteringUser = (state: AppState) => state.user.registeringUser;
